import Echo from 'laravel-echo'
import Vue from 'vue'

export default (context) => {
    const { appUrl, pusherAppKey, pusherHost } = context.$config

    const echo = {}

    echo.install = function (Vue) {
        Vue.prototype.$pusher = require('pusher-js')

        Vue.prototype.$echo = new Echo({
            authEndpoint: `${appUrl}/broadcasting/auth`,
            broadcaster: 'pusher',
            key: pusherAppKey,
            wsHost: pusherHost,
            cluster: 'eu',
            forceTLS: true,
            encrypted: true,
            disableStats: true,
        })
    }

    Vue.use(echo)
}
